<template>
  <div class="main">
    <div class="header">
      <img src="../assets/activitiesimg/top.png">
    </div>
    <div class="turntable">
      <div class="turntable-back">
        <img src="../assets/activitiesimg/turntable.png">
      </div>
      <div class="turntable-box">
        <luckdraw  @currentRow="currentRow" :luckyNum="luckyNum" :awardsNum="awardsNum"></luckdraw>
      </div>
    </div>
    <div class="awards">
      <div class="awards-img">
        <img src="../assets/activitiesimg/awards.svg" alt="">
      </div>
      <div class="awards-button" @click="shareShow">
        <img src="../assets/activitiesimg/share.png" alt="">
      </div>
      <div class="awards-box">
        <div class="awards-list" v-for="(item,i) in textArray" :key="i">
          <div class="awards-name">{{item.name}}</div>
          <div class="awards-text">{{item.text}}</div>
          <div class="awards-time">{{item.time}}</div>
        </div>
      </div>
      <div class="awards-total">累计中奖人数: 8888人</div>
    </div>
    <div class="rule">
      <div class="rule-img">
        <img src="../assets/activitiesimg/rule.svg" alt="">
      </div>
      <div class="rule-box">
        <div class="rule-img">
          <img src="../assets/activitiesimg/activityrules.svg">
        </div>
        <div class="rule-text">
          <strong>活动时间:</strong>
          <p>2020-11-05至2020-11-11</p>
          <strong>活动规则:</strong>
          <p>1.本活动仅限中科名兽医用户进行参与， 且每人每天只可参与3次，分享好友可增加1次抽奖机会。</p>
          <p>2.若在活动期间未使用抽奖机会，则活动结束后抽奖机会自动作废。</p>
        </div>
        <div class="rule-img">
          <img src="../assets/activitiesimg/activitydesc.svg">
        </div>
        <div class="rule-text">
          <p>1.抽奖成功后，实物奖品请添加客服微信(zkjy001)领取，我们将会在一周内安排发货，节假日顺延，奖品具体以实物为准，图片仅供参考。</p>
          <p>2.虚拟奖品将会及时发送到您的账户，下载中科名兽医APP线上检测可直接抵扣现金。</p>
          <p>3.凡以不正当手段作弊、扰乱系统、实施网络攻击等手段进行兑换，一经发现，平台有权终止奖品兑换。</p>
          <p>4.本次活动的最终解释权归中科名兽医所有。</p>
        </div>
        <div class="rule-qrcode">
          <img src="../assets/activitiesimg/qrcode.svg">
        </div>
        <div class="rule-qrcode-text">关注公众号了解更多</div>
      </div>
    </div>

    <van-dialog v-model="show1" class="vanstyle">
      <div class="prize-box">
        <div class="">
          <img src="../assets/activitiesimg/prize.svg" alt="">
        </div>
        <div class=""></div>
      </div>
    </van-dialog>
    
    <div class="modeshare" v-show="isModeShare">
      <div class="share-guide">
        <img src="../assets/activitiesimg/guide@2x.png" alt="">
      </div>
      <div class="share-ok">
        <img src="../assets/img/ok@2x.png" alt="" @click="shareHide">
      </div>
    </div>

  </div>

</template>



<script>
import luckdraw from '@/components/luckdraw'
export default {
  components:{
    luckdraw
  },
  data () {
    return {
      isModeShare: false,
      show: false,
      show1: false,
      phone: '',
      sms: '',
      luckyNum: 4, // 抽奖次数
      awardsNum: 5, // 获奖位置
      textArray: [
        { name:'小**', text:'抽中10元抵用卷', time: '10-27 15:22' },
        { name:'小**', text:'抽中10元抵用卷', time: '10-27 15:22' },
        { name:'小**', text:'抽中10元抵用卷', time: '10-27 15:22' },
        { name:'小**', text:'抽中10元抵用卷', time: '10-27 15:22' },
        { name:'小**', text:'抽中10元抵用卷', time: '10-27 15:22' },
        { name:'小**', text:'抽中10元抵用卷', time: '10-27 15:22' },
        { name:'小**', text:'抽中10元抵用卷', time: '10-27 15:22' },
        { name:'小**', text:'抽中10元抵用卷', time: '10-27 15:22' },
        { name:'小**', text:'抽中10元抵用卷', time: '10-27 15:22' },
        { name:'小**', text:'抽中10元抵用卷', time: '10-27 15:22' },
      ]
    }
  },
  computed: {},
  mounted () {},
  methods: {
    currentRow() {

    },
    /*======= 打开关闭弹出层 =======*/
    shareShow() {
      this.isModeShare = !this.isModeShare
    },
    shareHide() {
      this.isModeShare = !this.isModeShare
    },
  }
}
</script>

<style scoped lang="scss">
  .van-hairline--top,.van-dialog__footer {
    display: none !important;
  }
  .main {
    max-width: 780px;
    margin: 0 auto;
    font-size: 0;
    // background: linear-gradient(180deg,#0595ff, #2adaff 39%, #3bdeff 99%);
    .van-button--primary {
      background-color: #94a79d;
      border-radius: 8px;
      color: #fff;
    }
    .vanstyle {
      background-color: transparent;
    }
    .header {
      img {
        width: 100%;
      }
    }
    .turntable {
      position: relative;
      .turntable-back {
        img {
          width: 100%;
        }
      }
      .turntable-box {
        position: absolute;
        top: 272px;
        left: 100px;
      }
      @media screen and (max-width: 780px) {
        .turntable-box {
          position: absolute;
          top: 263px;
          left: 92px;
        }
      }
      @media screen and (max-width: 430px) {
        .turntable-box {
          position: absolute;
          top: 146px;
          left: 52px;
        }
      }
      @media screen and (max-width: 420px) {
        .turntable-box {
          position: absolute;
          top: 143px;
          left: 52px;
        }
      }
      @media screen and (max-width: 410px) {
        .turntable-box {
          position: absolute;
          top: 133px;
          left: 46px;
        }
      }
      @media screen and (max-width: 380px) {
        .turntable-box {
          position: absolute;
          top: 130px;
          left: 47px;
        }
      }
      @media screen and (max-width: 360px) {
        .turntable-box {
          position: absolute;
          top: 122px;
          left: 43px;
        }
      }
      @media screen and (max-width: 320px) {
        .turntable-box {
          position: absolute;
          top: 110px;
          left: 40px;
        }
      }
    }
    .awards {
      position: relative;
      font-size: 0;
      .awards-img {
        img {
          width: 100%;
        }
      }
      .awards-button {
        position: absolute;
        top: 15px;
        padding: 0 10%;
        img {
          width: 100%;
        }
      }
      .awards-box {
        position: absolute;
        width: 80%;
        top: 340px;
        left: 80px;
        .awards-list {
          display: flex;
          font-weight: bold;
          font-size: 22px;
          color: #F58A17;
          padding: 20px 0;
          .awards-name {
            flex: 0 0 60px;
          }
          .awards-text {
            flex: 1;
          }
          .awards-time {
            flex: 0 0 180px;
          }
        }
      }
      @media screen and (max-width: 780px) {
        .awards-box {
          position: absolute;
          width: 80%;
          top: 330px;
          left: 76px;
          .awards-list {
            display: flex;
            font-weight: bold;
            font-size: 18px;
            color: #F58A17;
            padding: 22px 0;
            .awards-name {
              flex: 0 0 60px;
            }
            .awards-text {
              flex: 1;
            }
            .awards-time {
              flex: 0 0 100px;
            }
          }
        }
      }
      @media screen and (max-width: 430px) {
        .awards-box {
          position: absolute;
          width: 80%;
          top: 190px;
          left: 42px;
          .awards-list {
            display: flex;
            font-weight: bold;
            font-size: 14px;
            color: #F58A17;
            padding: 10px 0;
            .awards-name {
              flex: 0 0 60px;
            }
            .awards-text {
              flex: 1;
            }
            .awards-time {
              flex: 0 0 100px;
            }
          }
        }
      }
      @media screen and (max-width: 420px) {
        .awards-box {
          position: absolute;
          width: 80%;
          top: 170px;
          left: 42px;
          .awards-list {
            display: flex;
            font-weight: bold;
            font-size: 14px;
            color: #F58A17;
            padding: 10px 0;
            .awards-name {
              flex: 0 0 60px;
            }
            .awards-text {
              flex: 1;
            }
            .awards-time {
              flex: 0 0 100px;
            }
          }
        }
      }
      @media screen and (max-width: 390px) {
        .awards-box {
          position: absolute;
          width: 80%;
          top: 170px;
          left: 38px;
          .awards-list {
            display: flex;
            font-weight: bold;
            font-size: 12px;
            color: #F58A17;
            padding: 10px 0;
            .awards-name {
              flex: 0 0 60px;
            }
            .awards-text {
              flex: 1;
            }
            .awards-time {
              flex: 0 0 100px;
            }
          }
        }
      }
      @media screen and (max-width: 380px) {
        .awards-box {
          position: absolute;
          width: 80%;
          top: 160px;
          left: 38px;
          .awards-list {
            display: flex;
            font-weight: bold;
            font-size: 12px;
            color: #F58A17;
            padding: 9px 0;
            .awards-name {
              flex: 0 0 60px;
            }
            .awards-text {
              flex: 1;
            }
            .awards-time {
              flex: 0 0 100px;
            }
          }
        }
      }
      @media screen and (max-width: 320px) {
        .awards-box {
          position: absolute;
          width: 80%;
          top: 140px;
          left: 32px;
          .awards-list {
            display: flex;
            font-weight: bold;
            font-size: 12px;
            color: #F58A17;
            padding: 7px 0;
            .awards-name {
              flex: 0 0 60px;
            }
            .awards-text {
              flex: 1;
            }
            .awards-time {
              flex: 0 0 100px;
            }
          }
        }
      }
      .awards-total {
        position: absolute;
        bottom: 45px;
        width: 100%;
        font-size: 22px;
        font-weight: bold;
        color: #CA3A00;
      }
      @media screen and (max-width: 780px) {
        .awards-total {
          position: absolute;
          bottom: 50px;
          width: 100%;
          font-size: 18px;
          font-weight: bold;
          color: #CA3A00;
        }
      }
      @media screen and (max-width: 430px) {
        .awards-total {
          position: absolute;
          bottom: 25px;
          width: 100%;
          font-size: 14px;
          font-weight: bold;
          color: #CA3A00;
        }
      }
      @media screen and (max-width: 420px) {
        .awards-total {
          position: absolute;
          bottom: 20px;
          width: 100%;
          font-size: 14px;
          font-weight: bold;
          color: #CA3A00;
        }
      }
      @media screen and (max-width: 380px) {
        .awards-total {
          position: absolute;
          bottom: 20px;
          width: 100%;
          font-size: 14px;
          font-weight: bold;
          color: #CA3A00;
        }
      }
      @media screen and (max-width: 320px) {
        .awards-total {
          position: absolute;
          bottom: 15px;
          width: 100%;
          font-size: 14px;
          font-weight: bold;
          color: #CA3A00;
        }
      }
    }
    .rule {
      position: relative;
      .rule-img {
        img {
          width: 100%;
        }
      }
      .rule-box {
        position: absolute;
        width: 100%;
        top: 150px;
        .rule-img {
          text-align: center;
          img {
            width: 288px;
            height: 64px;
          }
        }
        .rule-text {
          padding: 30px 105px;
          text-align: left;
          strong {
            font-size: 28px;
            font-weight: bold;
            color: #000;
          }
          p {
            font-size: 22px;
            color: #666666;
            padding-bottom: 30px;
            line-height: 50px;
          }
        }
        .rule-qrcode {
          img {
            width: 400px;
          }
        }
        .rule-qrcode-text {
          padding-top: 20px;
          text-align: center;
          font-size: 22px;
          font-weight: 400;
          color: #1C1D1F;
        }
      }
      @media screen and (max-width: 780px) {
        .rule-box {
          position: absolute;
          width: 100%;
          top: 100px;
          .rule-img {
            text-align: center;
            img {
              width: 400px;
              height: 100px;
            }
          }
          .rule-text {
            padding: 30px 115px;
            text-align: left;
            strong {
              font-size: 26px;
              font-weight: bold;
              color: #000;
            }
            p {
              font-size: 20px;
              color: #666666;
              padding-bottom: 20px;
              line-height: 40px;
            }
          }
          .rule-qrcode {
            img {
              width: 500px;
            }
          }
          .rule-qrcode-text {
            padding-top: 15px;
            text-align: center;
            font-size: 22px;
            font-weight: 400;
            color: #1C1D1F;
          }
        }
      }
      @media screen and (max-width: 430px) {
        .rule-box {
          position: absolute;
          width: 100%;
          top: 80px;
          .rule-img {
            text-align: center;
            img {
              width: 188px;
              height: 34px;
            }
          }
          .rule-text {
            padding: 10px 55px;
            text-align: left;
            strong {
              font-size: 16px;
              font-weight: bold;
              color: #000;
            }
            p {
              font-size: 14px;
              color: #666666;
              padding-bottom: 10px;
              line-height: 30px;
            }
          }
          .rule-qrcode {
            img {
              width: 200px;
            }
          }
          .rule-qrcode-text {
            padding-top: 5px;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #1C1D1F;
          }
        }
      }
      @media screen and (max-width: 420px) {
        .rule-box {
          position: absolute;
          width: 100%;
          top: 50px;
          .rule-img {
            text-align: center;
            img {
              width: 188px;
              height: 34px;
            }
          }
          .rule-text {
            padding: 10px 55px;
            text-align: left;
            strong {
              font-size: 16px;
              font-weight: bold;
              color: #000;
            }
            p {
              font-size: 14px;
              color: #666666;
              padding-bottom: 10px;
              line-height: 30px;
            }
          }
          .rule-qrcode {
            img {
              width: 200px;
            }
          }
          .rule-qrcode-text {
            padding-top: 5px;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #1C1D1F;
          }
        }
      }
      @media screen and (max-width: 410px) {
        .rule-box {
          position: absolute;
          width: 100%;
          top: 50px;
          .rule-img {
            text-align: center;
            img {
              width: 188px;
              height: 34px;
            }
          }
          .rule-text {
            padding: 10px 55px;
            text-align: left;
            strong {
              font-size: 16px;
              font-weight: bold;
              color: #000;
            }
            p {
              font-size: 14px;
              color: #666666;
              padding-bottom: 10px;
              line-height: 30px;
            }
          }
          .rule-qrcode-text {
            padding-top: 5px;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #1C1D1F;
          }
        }
      }
      @media screen and (max-width: 380px) {
        .rule-box {
          position: absolute;
          width: 100%;
          top: 50px;
          .rule-img {
            text-align: center;
            img {
              width: 188px;
              height: 34px;
            }
          }
          .rule-text {
            padding: 10px 55px;
            text-align: left;
            strong {
              font-size: 16px;
              font-weight: bold;
              color: #000;
            }
            p {
              font-size: 14px;
              color: #666666;
              padding-bottom: 10px;
              line-height: 20px;
            }
          }
          .rule-qrcode-text {
            padding-top: 5px;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #1C1D1F;
          }
        }
      }
      @media screen and (max-width: 320px) {
        .rule-box {
          position: absolute;
          width: 100%;
          top: 40px;
          .rule-img {
            text-align: center;
            img {
              width: 188px;
              height: 34px;
            }
          }
          .rule-text {
            padding: 5px 55px;
            text-align: left;
            strong {
              font-size: 14px;
              font-weight: bold;
              color: #000;
            }
            p {
              font-size: 12px;
              color: #666666;
              padding-bottom: 10px;
              line-height: 20px;
            }
          }
          .rule-qrcode {
            img {
              width: 170px;
            }
          }
          .rule-qrcode-text {
            padding-top: 0px;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #1C1D1F;
          }
        }
      }
    }
  }
  
  .modeshare{
    // display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.7);
    text-align: right;
    .share-guide {
      padding: 0.12rem 0.12rem 0 0.15rem;
      img {
        max-width: 80%
      }
    }
    .share-ok {
      margin: 20px 0 0;
      padding: 0;
      border: 0;
      font-size: 0;
      text-align: center;
      img {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 0;
        width: 1.4rem;
        height: 0.4rem;
      }
    }
  }
</style>